<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <Row :title="$t('AgreementNo')" :val="delivery.AgreementNo"></Row>
        <Row :title="$t('AgreementName')" :val="delivery.AgreementName"></Row>
        <Row :title="$t('Facility')"  :val="delivery.Facility"></Row>
      </v-col>
      <v-col cols="12" md="6">
        <Row :title="$t('DeliveryNo')" :val="delivery.No"></Row>
        <Row :title="$t('DeliveryName')" :val="delivery.Name"></Row>
        <Row :title="$t('Zip Code')" :val="delivery.CouplingNo"></Row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Row from '@/modules/workplaces/components/Row'
import formatDate from '@/core/mixins/formatDate'

export default {
  mixins: [formatDate],
  components: {
    Row
  },
  props: ['delivery']
}
</script>
